import route from "@/constants/route";
import { RootState } from "@/store";
import _ from "lodash";
import { useSelector } from "react-redux";
import { permissions } from "./permissions";
import { Auth } from "@/types/auth.type";

export const usePermissions = () => {
  const { auth } = useSelector((state: RootState) => state.auth);
  const hasPermission = (permissionName: string): boolean => {
    return auth && _.isObject(auth.rules) && auth.rules.hasOwnProperty(permissionName) ? auth.rules[permissionName].includes(auth.role.toString()) : false;
  };

  return { hasPermission };
};

export const hasPermission = (auth: Auth, path: string): boolean => {
  if (auth && _.isObject(auth.rules)) {
    let permission = ''
    switch(path) {
      case route.DASHBOARD:
      case route.CASHFLOW:
      case route.TRANSACTIONS.VIEW:
      case route.TRANSACTIONSQUERY.VIEW:
        permission = permissions.TRANSACTION.VIEW;
        break;
      // KPI requires separate permission - restricted to Admin and SuperAdmin only
      case route.KPI:
        permission = permissions.KPI.VIEW;
        break;
      case route.USERS.VIEW:
        permission = permissions.USER.VIEW;
        break;
      case route.RENTALS.VIEW:
        permission = permissions.RENTAL.VIEW
        break;
      case route.HOUSERENTALS.VIEW:
        permission = permissions.HOUSERENTAL.VIEW
        break;
      case route.SETTINGS.TENANT.VIEW:
        permission = permissions.TENANT.VIEW;
        break;
      case route.SETTINGS.BUSINESSUNITS.VIEW:
        permission = permissions.BUSINESSUNITS.VIEW;
        break;
      case route.SETTINGS.UNITCODES.VIEW:
        permission = permissions.UNITCODE.VIEW;
        break;
      case route.SETTINGS.TRANSACTIONTYPES.VIEW:
        permission = permissions.TRANSACTIONTYPE.VIEW;
        break;
      case route.SETTINGS.EXTERNALAPI.VIEW:
        permission = permissions.EXTERNALAPI.VIEW;
        break;
      case route.SETTINGS.PERMISSIONS.VIEW:
        permission = permissions.PERMISSION.VIEW;
        break;
      case route.AUDITLOGS:
        permission = permissions.AUDITLOG.VIEW;
        break;
      default:
        permission = ''
        break;
    }
    return auth.rules[permission] ? auth.rules[permission].includes(auth.role.toString()) : false
  }
  return false
}
